export default __webpack_public_path__ + "static/media/dyeing6.750944d2.png";